



















import { Vue, Component, Prop } from "vue-property-decorator";
import Loading from "vue-loading-overlay";
@Component({
  components: {
    Loading,
  },
})
export default class LoadingOverlay extends Vue {
  @Prop()
  isLoading!: boolean;
}
